"use client";

import { c as _c } from "react/compiler-runtime";
import { memo } from "react";
import Image from "next/image";
import Link from "@/components/ui/Link";
import LiveBlink from "@/components/ui/LiveBlink";
import { isLiveBlogValue } from "@/lib/liveBlog";
import { MessageIcon } from "../ui/message-icon";
import { BOOKMARK_CATEGORIES } from "@/lib/api/public-client";
import { FALLBACK_IMAGE } from '@/lib/constants';
import { getImageUrl, getTimeAgo, getFocusPointStyle, toFieldString, ImageMetadata, BLUR_PLACEHOLDER } from '@/lib/componentutills';
type FieldConfig = {
  hidden?: boolean;
  value?: string | boolean;
  customClass?: string;
};
type Props = {
  title?: FieldConfig;
  timeAgo?: FieldConfig;
  imageSrc?: FieldConfig;
  slug?: string;
  /** Mark as LCP image - preloads for faster rendering */
  priority?: boolean;
  imageMetadata?: ImageMetadata;
  templatetype?: FieldConfig;
  isliveblog?: FieldConfig;
};
const VerticalMediumImageNewsBuilderComponent = t0 => {
  const $ = _c(58);
  const {
    title: t1,
    timeAgo: t2,
    imageSrc: t3,
    slug,
    priority: t4,
    imageMetadata,
    templatetype: t5,
    isliveblog: t6
  } = t0;
  let t7;
  if ($[0] !== t1) {
    t7 = t1 === undefined ? {
      hidden: false,
      value: "\u0BB2\u0BCB\u0B95\u0BC7\u0BB7\u0BCD \u0B95\u0BA9\u0B95\u0BB0\u0BBE\u0B9C\u0BCD \u0B87\u0BAF\u0B95\u0BCD\u0B95\u0BC1\u0BB5\u0BA4\u0BC1 \u0BB0\u0B9C\u0BBF\u0BA9\u0BBF\u0BAF\u0BBF\u0BA9\u0BCD \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BAA\u0B9F\u0BAE\u0BBE? \u0BA8\u0B9F\u0BBF\u0B95\u0BB0\u0BCD \u0BB0\u0B9C\u0BBF\u0BA9\u0BBF\u0B95\u0BBE\u0BA8\u0BCD\u0BA4\u0BCD '\u0B9C\u0BC6\u0BAF\u0BBF\u0BB2\u0BB0\u0BCD' \u0BAA\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BA8\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BC1\u0BB3\u0BCD\u0BB3\u0BBE\u0BB0\u0BCD.",
      customClass: ""
    } : t1;
    $[0] = t1;
    $[1] = t7;
  } else {
    t7 = $[1];
  }
  const title = t7;
  let imageSrc;
  let isliveblog;
  let priority;
  let t8;
  let templatetype;
  let timeAgo;
  let timeAgoValue;
  let titleValue;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== t4 || $[5] !== t5 || $[6] !== t6 || $[7] !== title?.value) {
    timeAgo = t2 === undefined ? {
      hidden: false,
      value: "21 min ago",
      customClass: ""
    } : t2;
    imageSrc = t3 === undefined ? {
      hidden: false,
      value: FALLBACK_IMAGE,
      customClass: ""
    } : t3;
    priority = t4 === undefined ? false : t4;
    let t9;
    if ($[16] !== t5) {
      t9 = t5 === undefined ? {
        hidden: false,
        value: "",
        customClass: ""
      } : t5;
      $[16] = t5;
      $[17] = t9;
    } else {
      t9 = $[17];
    }
    templatetype = t9;
    let t10;
    if ($[18] !== t6) {
      t10 = t6 === undefined ? {
        hidden: false,
        value: "",
        customClass: ""
      } : t6;
      $[18] = t6;
      $[19] = t10;
    } else {
      t10 = $[19];
    }
    isliveblog = t10;
    const t11 = title?.value;
    let t12;
    if ($[20] !== t11) {
      t12 = toFieldString(t11);
      $[20] = t11;
      $[21] = t12;
    } else {
      t12 = $[21];
    }
    titleValue = t12;
    timeAgoValue = getTimeAgo(toFieldString(timeAgo?.value));
    t8 = getImageUrl(toFieldString(imageSrc?.value)) || FALLBACK_IMAGE;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = title?.value;
    $[8] = imageSrc;
    $[9] = isliveblog;
    $[10] = priority;
    $[11] = t8;
    $[12] = templatetype;
    $[13] = timeAgo;
    $[14] = timeAgoValue;
    $[15] = titleValue;
  } else {
    imageSrc = $[8];
    isliveblog = $[9];
    priority = $[10];
    t8 = $[11];
    templatetype = $[12];
    timeAgo = $[13];
    timeAgoValue = $[14];
    titleValue = $[15];
  }
  const imageSrcValue = t8;
  let t9;
  if ($[22] !== isliveblog?.value || $[23] !== templatetype?.value) {
    t9 = isLiveBlogValue(templatetype?.value) || isLiveBlogValue(isliveblog?.value);
    $[22] = isliveblog?.value;
    $[23] = templatetype?.value;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const isLiveBlog = t9;
  let t10;
  if ($[25] !== imageMetadata || $[26] !== imageSrc?.customClass || $[27] !== imageSrc?.hidden || $[28] !== imageSrcValue || $[29] !== priority || $[30] !== titleValue) {
    t10 = !imageSrc?.hidden && <div className={`relative w-full aspect-[16/9] overflow-hidden ${imageSrc?.customClass || ""}`} style={{
      contain: "layout"
    }}><Image src={imageSrcValue} alt={titleValue} fill={true} priority={priority} className="object-cover" style={getFocusPointStyle(imageMetadata)} loading={priority ? "eager" : "lazy"} fetchPriority={priority ? "high" : "auto"} sizes="(max-width: 768px) 100vw, (max-width: 1200px) 33vw, 300px" placeholder="blur" blurDataURL={BLUR_PLACEHOLDER} /></div>;
    $[25] = imageMetadata;
    $[26] = imageSrc?.customClass;
    $[27] = imageSrc?.hidden;
    $[28] = imageSrcValue;
    $[29] = priority;
    $[30] = titleValue;
    $[31] = t10;
  } else {
    t10 = $[31];
  }
  let t11;
  if ($[32] !== isLiveBlog || $[33] !== title?.customClass || $[34] !== title?.hidden || $[35] !== titleValue) {
    t11 = !title?.hidden && <h3 className={`text-14-tamil-700 text-1B1B1B leading-[1.4] h-auto ${title?.customClass || ""}`}>{isLiveBlog && <LiveBlink className="gap-1.5 mr-2" />}{titleValue}</h3>;
    $[32] = isLiveBlog;
    $[33] = title?.customClass;
    $[34] = title?.hidden;
    $[35] = titleValue;
    $[36] = t11;
  } else {
    t11 = $[36];
  }
  let t12;
  if ($[37] !== timeAgo?.customClass || $[38] !== timeAgo?.hidden || $[39] !== timeAgoValue) {
    t12 = !timeAgo?.hidden && <span className={`text-12-tamil-500 text-1B1B1B ${timeAgo?.customClass || ""}`}>{timeAgoValue}</span>;
    $[37] = timeAgo?.customClass;
    $[38] = timeAgo?.hidden;
    $[39] = timeAgoValue;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  const t13 = slug ? `/${slug}` : undefined;
  let t14;
  if ($[41] !== imageSrcValue || $[42] !== slug || $[43] !== t13 || $[44] !== titleValue) {
    t14 = <div className="flex gap-3"><MessageIcon id="message-icon-1" slug={slug} category={BOOKMARK_CATEGORIES.NEWS} title={titleValue} thumbnailUrl={imageSrcValue} articleUrl={t13} /></div>;
    $[41] = imageSrcValue;
    $[42] = slug;
    $[43] = t13;
    $[44] = titleValue;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== t12 || $[47] !== t14) {
    t15 = <div className="flex items-center justify-between gap-2">{t12}{t14}</div>;
    $[46] = t12;
    $[47] = t14;
    $[48] = t15;
  } else {
    t15 = $[48];
  }
  let t16;
  if ($[49] !== t11 || $[50] !== t15) {
    t16 = <div className="flex flex-col gap-3">{t11}{t15}</div>;
    $[49] = t11;
    $[50] = t15;
    $[51] = t16;
  } else {
    t16 = $[51];
  }
  let t17;
  if ($[52] !== t10 || $[53] !== t16) {
    t17 = <div className="flex flex-col overflow-hidden p-4 gap-4 bg-F8F8F8">{t10}{t16}</div>;
    $[52] = t10;
    $[53] = t16;
    $[54] = t17;
  } else {
    t17 = $[54];
  }
  const content = t17;
  if (slug) {
    const t18 = `/${slug}`;
    let t19;
    if ($[55] !== content || $[56] !== t18) {
      t19 = <Link href={t18} className="block  transition-colors cursor-pointer">{content}</Link>;
      $[55] = content;
      $[56] = t18;
      $[57] = t19;
    } else {
      t19 = $[57];
    }
    return t19;
  }
  return content;
};

// Memoize to prevent unnecessary re-renders
export const VerticalMediumImageNewsBuilder = memo(VerticalMediumImageNewsBuilderComponent);